var exports = {
  "x2": "buttonChildrenWrapper__R817fz",
  "F3": "LoadMoreContainer__SA0BWG",
  "YR": "loadMoreContentContainer__Qg1Clv",
  "RX": "innerContentWrapper__0lTRlX",
  "oe": "centeredContent__GXvLUU",
  "Mj": "headingWrapper__Vj7xPN",
  "nt": "remainingItemsHeading__DW2RIn",
  "_o": "buttonWrapper__BcMgD5",
};

module.exports = exports;
